<template>
  <v-container class="py-0 px-0 px-md-4" fluid>
    <v-row>
      <v-col md="4" cols="12" v-if="dashboardData.chart1">
        <component
          v-bind:is="dashboardData.chart1.type"
          :title="dashboardData.chart1.title"
          :options="dashboardData.chart1.options"
          @filter="filter"
          :height="200"
        ></component>
      </v-col>
      <v-col md="4" cols="12" v-if="dashboardData.chart2">
        <component
          v-bind:is="dashboardData.chart2.type"
          :title="dashboardData.chart2.title"
          :options="dashboardData.chart2.options"
          @filter="filter"
          :height="200"
        ></component>
      </v-col>
      <v-col md="4" cols="12" v-if="dashboardData.chart3">
        <component
          v-bind:is="dashboardData.chart3.type"
          :title="dashboardData.chart3.title"
          :options="dashboardData.chart3.options"
          @filter="filter"
          :height="200"
        ></component>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="4" cols="12" v-if="dashboardData.chart4">
        <component
          v-bind:is="dashboardData.chart4.type"
          :title="dashboardData.chart4.title"
          :options="dashboardData.chart4.options"
          @filter="filter"
          :height="200"
        ></component>
      </v-col>
      <v-col md="4" cols="12" v-if="dashboardData.chart5">
        <component
          v-bind:is="dashboardData.chart5.type"
          :title="dashboardData.chart5.title"
          :options="dashboardData.chart5.options"
          @filter="filter"
          :height="200"
        ></component>
      </v-col>
      <v-col md="4" cols="12" v-if="dashboardData.chart6">
        <component
          v-bind:is="dashboardData.chart6.type"
          :title="dashboardData.chart6.title"
          :options="dashboardData.chart6.options"
          @filter="filter"
          :height="200"
        ></component>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6" cols="12" v-if="dashboardData.chart7">
        <component
          v-bind:is="dashboardData.chart7.type"
          :title="dashboardData.chart7.title"
          :options="dashboardData.chart7.options"
          @filter="filter"
          :height="200"
        ></component>
      </v-col>
      <v-col md="6" cols="12" v-if="dashboardData.chart8">
        <component
          v-bind:is="dashboardData.chart8.type"
          :title="dashboardData.chart8.title"
          :options="dashboardData.chart8.options"
          @filter="filter"
          :height="200"
        ></component>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DashboardMixin from "@/components/mixins/dashboard.js";

export default {
  mixins: [DashboardMixin],
};
</script>


<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}
.col-md-4, .col-md-6{
  padding: 6px !important;
}
</style>